import en from "./en.json";

const languages = {
  en,
};

export default languages;
